"use client";
import React from "react";

import { Markdown } from "~/components/markdown/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { RICH_TEXT_BLOCK_CLASSES } from "./constants";
import { RichTextBlockContainer } from "./styled";
import { RichTextBlockProps } from "./types";

export const RichTextBlock: React.FC<RichTextBlockProps> = ({
  text,
  testAutomationId = "rich-text-block",
}) => {
  const idValue = `${testAutomationId}-rich-text-container`;
  return (
    <RichTextBlockContainer
      {...getTestAutomationProps(testAutomationId)}
      id={idValue}
    >
      {text && <Markdown className={RICH_TEXT_BLOCK_CLASSES.richText} text={text} />}
    </RichTextBlockContainer>
  );
};
